import { Main } from './components';

const ClientRules = () => <Main />;

export default ClientRules;

